import ScrollHint from 'scroll-hint'
import { index } from "./components/index";
import { tab } from "./components/tab";
import Splide from '@splidejs/splide';

index();

const hamburger = document.querySelector('.l-hamburger');
const drawer = document.querySelector('.l-drawer');

hamburger.addEventListener('click', () => {
	hamburger.classList.toggle('_active');
	drawer.classList.toggle('_active');
})

if (document.querySelector('.p-voice')) {
	tab('.p-voice');
}


const pageTopButton = document.querySelector('.l-pagetop');

window.addEventListener('scroll', function () {

	if (window.pageYOffset > 100) { // スクロール量が100ピクセルを超えた場合に表示
		pageTopButton.classList.add('_show');
	} else {
		pageTopButton.classList.remove('_show');
	}
});

pageTopButton.addEventListener('click', function () {
	scrollToTop();
});



function scrollToTop() {
	var currentPosition = window.pageYOffset;
	var targetPosition = 0;
	var distance = targetPosition - currentPosition;
	var duration = 500; // スクロールの時間（ミリ秒）

	var start = null;
	window.requestAnimationFrame(step);

	function step(timestamp) {
		if (!start) start = timestamp;
		var progress = timestamp - start;
		window.scrollTo(0, easeInOutCubic(progress, currentPosition, distance, duration));
		if (progress < duration) {
			window.requestAnimationFrame(step);
		}
	}

	// イージング関数（cubic easing）
	function easeInOutCubic(t, b, c, d) {
		t /= d / 2;
		if (t < 1) return c / 2 * t * t * t + b;
		t -= 2;
		return c / 2 * (t * t * t + 2) + b;
	}
}


document.addEventListener('DOMContentLoaded', function () {
	new ScrollHint('.js-scrollable');

})


if (document.querySelector('.p-graduate__update')) {

	const splide = new Splide('.splide', {
		type: 'loop',
		speed: 1000,
		autoplay: true,
		interval: 6000,
		padding: '14.28vw',
		gap: 0,
		pagination: false,
		breakpoints: {

			640: {
				padding: '0px',
				gap: '0px'
			}
		}
	});

	splide.mount();
}
